<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base">
                        <div>
                          <vs-input :label="$t('Labels.Serie')" :placeholder="$t('Labels.Serie')" v-model="data.serie" v-mask="'##;######;#;#'"/>
                        </div>
                        <div class="text-right">
                          <vs-button @click="requestPassword()" class="bg-primary mt-4" type="filled">{{$t("Labels.Save")}}</vs-button>
                        </div>
                    </vx-card>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    vSelect
  },

  data () {
    return {
      clients: [],
      uuid: this.$route.params.uuid,
      data:{
        serie: '',
        port: '',
        app: {},
        profile: {}
      }
    }
  },

  methods: {
    async init () {
      this.apps = [
        { description:'App 1', app_id:'1'},
        { description:'App 2', app_id:'2'},
        { description:'App 3', app_id:'3'}
      ]

      this.profiles = [
        { description:'Profile 1', device_profile_uuid:'1'},
        { description:'Profile 2', device_profile_uuid:'2'},
        { description:'Profile 3', device_profile_uuid:'3'}
      ]

      const params = {
        url: `devices/${this.uuid}`,
        method: 'GET',
        params: {
          limit: 0
        }
      }
      await request(params).then(response => {
        this.data = response.data.data
      })             
    },
    requestPassword () {
      globalPassActions.show()
    },
    async update () {
      const params = {
        url: `devices/${this.uuid}`,
        method: 'PUT',
        params: this.data
      }
      await request(params).then(response => {
        this.data = response.data.data
      })       
    }
  },
  created () {
    this.init()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.update()
    }
  }
}
</script>
